import React from 'react';
import { observer } from 'mobx-react';
import { TranslationsLinks } from '~sharedComponents/Providers/Translations/TranslationsContext';
import { useTranslation } from '~sharedComponents/Providers/Translations/TranslationsHook';
import { fillTranslation } from '~sharedComponents/Providers/Translations/utils/fillTranslation';
import TextLabel from '~sharedComponents/TextLabel/TextLabel';
import { StyledParagraphFooter } from './ReplenishmentTooltipModalStyles';
import { replenishmentParagraphFooterModalClass, translationsList } from './utils';

export const ReplenishmentTooltipModalFooter = observer(() => {
    const {
        autoReplenishmentTermsAndConditions,
        autoReplenishmentFrequentlyAskedQuestions,
        autoReplenishmentTermsConditionsAndFaq
    } = useTranslation(translationsList);

    const { html: autoReplenishmentTCLink } =
        autoReplenishmentTermsAndConditions as unknown as TranslationsLinks;
    const { html: autoReplenishmentFAQLink } =
        autoReplenishmentFrequentlyAskedQuestions as unknown as TranslationsLinks;
    const termsAndConditionsWithLinks = fillTranslation(autoReplenishmentTermsConditionsAndFaq, {
        terms_and_conditions: autoReplenishmentTCLink,
        frequently_asked_questions: autoReplenishmentFAQLink
    });

    return (
        <StyledParagraphFooter
            className={replenishmentParagraphFooterModalClass}
            data-content="text"
        >
            <TextLabel text={termsAndConditionsWithLinks} />
        </StyledParagraphFooter>
    );
});
